function alt(event, keysPressed) {
  // note - alt space is not preventable (system reserved)

  // shows context menu - main chrome menu
  if (keysPressed['Alt'] && event.key == 'e') {
    event.preventDefault();
    console.log("alt+e");
  }

  // shows context menu - main chrome menu
  if (keysPressed['Alt'] && event.key == 'f') {
    event.preventDefault();
    console.log("alt+f");
  }

  // chrome - go back in history
  if (keysPressed['Alt'] && event.key == 'ArrowLeft') {
    event.preventDefault();
    console.log("alt+ArrowLeft");
  }

  // chrome - go forward in history
  if (keysPressed['Alt'] && event.key == 'ArrowRight') {
    event.preventDefault();
    console.log("alt+ArrowLeft");
  }
}

export { alt }